import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Maplekeep replaced my entire workflow. I used to juggle three apps and a paper notebook. Now every pin, note, and route lives on one beautiful canvas.',
  author: 'Theron Voss',
  role: 'Trail Cartographer'
}, {
  quote: "The Fieldbook feature changed how I document journeys. Notes anchored to coordinates — it's like my journal finally learned to read a map.",
  author: 'Isolde Kairn',
  role: 'Expedition Planner'
}, {
  quote: 'Meridian Tools alone is worth the subscription. Coordinate conversion and waypoint generation that actually works for field researchers.',
  author: 'Caspian Drey',
  role: 'Geo-Data Researcher'
}];
export function TestimonialsSection() {
  return <section className="py-24 bg-parchment relative overflow-hidden" data-id="element-209">
      <div className="absolute inset-0 bg-paper-texture opacity-50 pointer-events-none" data-id="element-210" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-211">
        <div className="text-center mb-16" data-id="element-212">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-forest mb-4" data-id="element-213">
            From the Field
          </h2>
          <div className="w-24 h-1 bg-terracotta mx-auto rounded-full" data-id="element-214" />
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-215">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} viewport={{
          once: true
        }} className="bg-white/50 p-8 rounded-sm shadow-sm border border-brown/10 relative" data-id="element-216">
              <Quote className="absolute top-4 left-4 w-8 h-8 text-terracotta/20" data-id="element-217" />

              <p className="text-lg font-serif italic text-forest/80 mb-6 relative z-10 leading-relaxed" data-id="element-218">
                "{item.quote}"
              </p>

              <div className="border-t border-brown/10 pt-4" data-id="element-219">
                <p className="font-bold text-forest" data-id="element-220">{item.author}</p>
                <p className="text-sm text-terracotta uppercase tracking-wider" data-id="element-221">
                  {item.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}